<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='带教老师信息' :label2='this.title' url="/person/teach/list"></PageHead>
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <!--begin: Search Form -->
        <div class="m-form m-form--label-align-right">
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">评分开始时间：</label>
              </div>
              <div class="m-form__control">
                <el-date-picker v-model="condition.startdate" value-format="yyyy-MM" type="month" placeholder="开始月份">
                </el-date-picker>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">评分结束时间：</label>
              </div>
              <div class="m-form__control">
                <el-date-picker v-model="condition.enddate" value-format="yyyy-MM" type="month" placeholder="结束月份">
                </el-date-picker>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
          <SearchButton :url='searchUrl' ref="btnSearch"></SearchButton>
        </div>
        <!--end: Search Form -->
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <!--begin: Datatable -->
          <el-table v-loading="loading" :data="tableData" stripe style="width: 100%" size="medium" @row-click="CPIInfo">
            <el-table-column label="评分时间">
              <template slot-scope="scope">
                {{scope.row.CPIDate|formatDate}}
              </template>
            </el-table-column>
            <el-table-column prop="CPIDScore" label="得分">
            </el-table-column>
          </el-table>
          <div style="text-align:center;width: 100%;height: 57px; line-height: 57px;" v-if="this.condition.recordCount > 0">
            <span>最低分：{{this.minscore}}</span><span style="padding-left: 30px;">最高分：{{this.maxscore}}</span><span style="padding-left: 30px;">平均分：{{this.avgscore}}</span><span style="padding-left: 30px;">评分次数：{{this.scorenum}}</span>
          </div>
          <!--end: Datatable -->
          <div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="condition.currentPage"
              :page-sizes="[2, 10, 20, 30, 40]" :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="condition.recordCount">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScoreList',
  data () {
    return {
      condition: {
        cpitype: '2',
        id: '',
        tecid: '',
        startdate: '',
        enddate: '',
        token: '',
        pageSize: 10,
        currentPage: 1,
        recordCount: 0,
        firstSearch: true
      },
      minscore: '0',
      maxscore: '0',
      avgscore: '0',
      scorenum: '0',
      tecname: '',
      secname: '',
      title: '',
      tableData: null,
      searchUrl: this.$utils.Url.zpgl + '/api/APITeacher/CPIDetailList',
      loading: true
    }
  },
  filters: {
    formatDate (val) {
      var now = new Date(val)
      var y = now.getFullYear()
      var m = now.getMonth() + 1
      return y + '-' + (m < 10 ? '0' + m : m)
    }
  },
  methods: {
    // 调整每页显示数
    handleCurrentChange: function (val) {
      this.condition.firstSearch = false
      this.condition.currentPage = val
      this.$refs.btnSearch.Search()
    },
    // 分页操作
    handleSizeChange: function (val) {
      this.condition.firstSearch = false
      this.condition.pageSize = val
      this.condition.currentPage = 1
      this.$refs.btnSearch.Search()
    },
    CPIInfo: function (row) {
      var fd = this.$options.filters['formatDate']
      this.$router.push({name: 'TeachScoreRecord', params: {id: row.CPIDID, month: fd(row.CPIDate)}})
    },
    LoadTecInfo: function () {
      this.$http.post(this.$utils.Url.zpgl + '/api/APITeacher/Info', this.condition)
        .then(res => {
          if (res.data.Code === 0) {
            this.minscore = res.data.Data.MinScore
            this.maxscore = res.data.Data.MaxScore
            this.avgscore = res.data.Data.AvgScore
            this.scorenum = res.data.Data.ScoreCount
          } else {
            this.$message({
              message: res.data.Msg + '，' + res.data.Error,
              type: 'error'
            })
          }
        })
        .catch(err => {
          console.log(err)
          this.$message({
            message: '查询失败',
            type: 'error'
          })
        })
    }
  },
  mounted: function () {
    this.condition.token = sessionStorage.getItem('token')
    this.condition.tecid = this.$route.params.tecid
    this.condition.id = this.$route.params.tecid
    this.tecname = this.$route.params.tecname
    this.secname = this.$route.params.secname
    this.title = this.tecname + '(' + this.secname + ')评分列表'
    this.$refs.btnSearch.Search()
    this.LoadTecInfo()
  }
}
</script>

<style>
</style>
